import { playUiClick } from '../../assets/preloadSounds';
import type { FailDeliveryScreenModel } from './FailDeliveryScreenModelScreen';

export class FailDeliveryScreenController {
  constructor(private readonly model: FailDeliveryScreenModel) {}

  handleRestart = () => {
    if (!this.model.canRestart) {
      return;
    }
    playUiClick();
    this.model.onRestart?.();
  };

  handleGoHome = () => {
    playUiClick();
    this.model.onGoHome?.();
  };
}
